import { render, staticRenderFns } from "./arvioinnit-vastuuhenkilo.vue?vue&type=template&id=1b7ebfb2&"
import script from "./arvioinnit-vastuuhenkilo.vue?vue&type=script&lang=ts&"
export * from "./arvioinnit-vastuuhenkilo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports